import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/DesigningEfficientSMPSCoalHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-41.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .desc { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .desc-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .desc-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .desc-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .desc-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .desc-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .desc-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .desc-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .desc-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .desc-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .desc-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .desc-bc-item:hover { color: #EB2019; }
  .desc-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .desc-bc-sep img { width: 24px; height: 24px; display: block; }
  .desc-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .desc-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .desc-main-section { padding: 80px 0 120px 0; }
  .desc-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .desc-article { flex: 1; min-width: 0; }

  .desc-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .desc-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .desc-meta-item:last-child { border-right: none; padding-right: 0; }
  .desc-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .desc-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .desc-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .desc-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .desc-article-body p { margin-bottom: 20px; }
  .desc-article-body p:last-child { margin-bottom: 0; }

  .desc-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .desc-h2-large {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin: 20px 0 20px 0; line-height: 140%; display: block;
  }

  /* Numbered ol list */
  .desc-article-body ol {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: desc-counter;
  }
  .desc-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: desc-counter;
  }
  .desc-article-body ol li::before {
    content: counter(desc-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .desc-article-body ol li > span { flex: 1; }

  .desc-article-body strong { font-weight: 600; color: #202020; }

  .desc-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: block; margin-bottom: 20px;
  }
  .desc-red-link:hover { opacity: 0.8; }

  .desc-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .desc-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .desc-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .desc-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .desc-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .desc-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .desc-nav-btn:hover { color: #EB2019; }
  .desc-nav-btn img { width: 40px; height: 40px; display: block; }

  .desc-share-icons { display: flex; align-items: center; gap: 20px; }
  .desc-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .desc-share-icon:hover { opacity: 0.85; }
  .desc-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .desc-sidebar { flex: 0 0 475px; }
  .desc-sidebar-block { margin-bottom: 60px; }
  .desc-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .desc-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .desc-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .desc-recent-item:hover .desc-recent-title { color: #EB2019; }
  .desc-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .desc-recent-body { flex: 1; min-width: 0; }
  .desc-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .desc-social-icons { display: flex; align-items: center; gap: 30px; }
  .desc-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .desc-social-icon:hover { opacity: 0.8; }
  .desc-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .desc-hero             { height: 350px; }
    .desc-hero-content     { padding: 0 32px; }
    .desc-hero-title       { font-size: 30px; }
    .desc-hero-divider     { width: 100%; max-width: 575px; }
    .desc-breadcrumb       { padding: 24px 0 0 0; }
    .desc-breadcrumb-inner { padding: 0 32px; }
    .desc-inner            { padding: 0 32px; }
    .desc-main-section     { padding: 48px 0 60px 0; }
    .desc-main-row         { flex-direction: column; gap: 48px; }
    .desc-sidebar          { flex: none; width: 100%; }
    .desc-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .desc-hero             { height: 360px; }
    .desc-hero-content     { padding: 0 16px; }
    .desc-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .desc-hero-divider     { width: 100%; }
    .desc-hero-subtitle    { font-size: 14px; }
    .desc-breadcrumb       { padding: 30px 0 0 0; }
    .desc-breadcrumb-inner { padding: 0 16px; }
    .desc-bc-item          { font-size: 14px; gap: 14px; }
    .desc-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .desc-bc-sep img       { width: 22px; height: 22px; }
    .desc-inner            { padding: 0 16px; }
    .desc-main-section     { padding: 30px 0 60px 0; }
    .desc-main-row         { flex-direction: column; gap: 60px; }
    .desc-sidebar          { flex: none; width: 100%; }
    .desc-article-title    { font-size: 20px; margin-bottom: 15px; }
    .desc-article-body     { font-size: 14px; }
    .desc-article-body p   { margin-bottom: 15px; }
    .desc-article-body ol  { margin: 20px 0 20px 0; gap: 20px; }
    .desc-article-body ol li { font-size: 14px; }
    .desc-article-body strong { font-size: 16px; }
    .desc-meta-item        { font-size: 14px; }
    .desc-meta-item:nth-child(2) { border-right: none; padding-right: 0; }
    .desc-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .desc-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .desc-h2-large         { font-size: 24px; margin: 30px 0 20px 0; }
    .desc-hashtags         { margin-top: 30px; font-size: 14px; }
    .desc-nav-btn img      { width: 24px; height: 24px; }
    .desc-nav-btn          { font-size: 14px; }
    .desc-share-icon img   { width: 34px; height: 34px; }
    .desc-sidebar-title    { font-size: 20px; }
    .desc-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function DesigningEfficientSMPSCoal() {
  return (
    <div className="desc">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="desc-hero">
        <img className="desc-hero-bg" src={HeroBgImg} alt="Designing Efficient SMPS Coal-Fired Power Plants Hero" />
        <div className="desc-hero-overlay" />
        <div className="desc-hero-content">
          <h1 className="desc-hero-title">
            Designing Efficient SMPS for Coal-Fired Power Plants: Key Considerations and Common Applications
          </h1>
          <hr className="desc-hero-divider" />
          <p className="desc-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="desc-breadcrumb" aria-label="Breadcrumb">
        <div className="desc-breadcrumb-inner">
          <a href="/" className="desc-bc-item">Home</a>
          <span className="desc-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="desc-bc-item">News &amp; Updates</a>
          <span className="desc-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="desc-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="desc-main-section">
        <div className="desc-inner">
          <div className="desc-main-row">

            {/* ── ARTICLE ── */}
            <article className="desc-article">

              {/* Meta bar */}
              <div className="desc-meta-bar">
                <span className="desc-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="desc-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="desc-meta-item"><img src={ClockIconImg} alt="time" /> 4:39 am</span>
                <span className="desc-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="desc-article-title">
                Designing Efficient SMPS for Coal-Fired Power Plants: Key Considerations and Common Applications
              </h1>

              {/* Body */}
              <div className="desc-article-body">

                <p>Ensuring effective emission control and operational efficiency is paramount in coal-fired power plants. Switch-mode Power Supplies (SMPS) play a pivotal role in achieving these objectives. As highly efficient power conversion systems, SMPS are essential for powering key equipment, including electrostatic precipitators (ESPs), which are designed to capture particulate matter from flue gases before they are released into the atmosphere.</p>

                <p>By delivering precise and reliable high-voltage DC power, SMPS enhances the performance of ESPs, ensuring that harmful emissions are minimized. This helps coal-fired plants meet stringent environmental regulations while optimizing their overall operational efficiency.</p>

                {/* Article image */}
                <img className="desc-article-img" src={ArticleImg} alt="Designing Efficient SMPS Coal-Fired Power Plants" />

                <p>Let us explore the key considerations when designing an efficient SMPS for coal-fired power plants and its typical applications.</p>

                <span className="desc-h2">Comprehending SMPS in Coal-Fired Power Plants</span>

                <p><a href="#" className="desc-red-link-plain">Switch-mode power Supply (SMPS)</a> is an efficient power supply that convert electrical energy using high-frequency switching. By rapidly toggling between on and off states, SMPS deliver regulated output voltage with minimal energy loss, ensuring high efficiency.</p>

                <p>In coal-fired power plants, <strong>SMPS</strong> power critical systems such as electrostatic precipitators (ESPs), fans, and pumps, playing a key role in optimizing overall plant performance and controlling emissions. Unlike traditional power supplies, which are prone to significant energy losses, <strong>SMPS</strong> reduce energy wastage, allowing the plant to operate at peak efficiency while maintaining compliance with environmental regulations.</p>

                <span className="desc-h2">Critical Considerations for Designing Efficient SMPS</span>

                <p>When designing <strong>SMPS</strong> for coal-fired power plants, there are several important factors to consider:</p>

                <ol>
                  <li><span><strong>Power Output Requirements</strong><br />
                  Coal-fired power plants have significant energy demands, with each system requiring specific power levels. SMPS must be designed to provide the precise power needed for each application, such as powering electrostatic precipitators (ESPs) for emission control or large motors for fans and pumps. Ensuring that the SMPS consistently delivers the required power without sacrificing efficiency is essential for optimal plant performance.</span></li>

                  <li><span><strong>Energy Efficiency</strong><br />
                  Energy efficiency is crucial for reducing the environmental impact of coal-fired power plants. An efficient SMPS should minimize energy losses during power conversion, helping to lower the plant's carbon footprint. Through high-frequency switching, <a href="#" className="desc-red-link-plain">SMPS power</a> systems can achieve efficiency levels of 90% or higher, ensuring that more power reaches the load and less is wasted as heat.</span></li>

                  <li><span><strong>Reliability and Durability</strong><br />
                  Functional downtime in coal-fired power plants can usher in significant financial upsets and regulatory damages. Thus, <strong>SMPS</strong> must be designed for durability and trustworthiness in extreme environments. The capability to resist fluctuations in load, temperature, and other environmental circumstances is vital for assuring constant function without loss.</span></li>

                  <li><span><strong>Thermal Management</strong><br />
                  Since SMPS functions at elevated frequencies, heat generation is a natural byproduct. Appropriate thermal management is critical to control overheating, which can devalue components and lead to system losses. To ensure longevity and reliability, adequate cooling means, such as heat sinks and ventilation, must be integrated into the SMPS design.</span></li>

                  <li><span><strong>Control and Monitoring</strong><br />
                  Modern SMPS designs incorporate advanced control systems that allow real-time monitoring and adjustments. This ensures optimal performance and allows plant operators to detect and address issues before they lead to failure. Remote monitoring capabilities also enhance the power plant's operational efficiency.</span></li>
                </ol>

                <p>Here's an extended version of your content with an additional 500 words, staying focused on coal-fired power plant applications and avoiding the inclusion of SMPS, as requested:</p>

                <span className="desc-h2-large">Common Applications of SMPS in Coal-Fired Power Plants</span>

                <p>SMPS power supplies are used in various applications within coal-fired power plants to assure smooth function and regulatory adherence. Some typical applications include:</p>

                <span className="desc-h2">Electrostatic Precipitators (ESPs)</span>

                <p>Electrostatic precipitators are crucial for regulating emissions in coal-fired power plants. SMPS delivers the high-voltage power required to charge the plates inside the ESP, assuring that particulate matter, ash, and soot are caught from flue gases before they are released into the environment.</p>

                <span className="desc-h2">Motor Control</span>

                <p>Large motors power essential equipment such as fans, pumps, and conveyors in coal-fired power plants for efficient functioning! SMPS provides regulated power to these motors, ensuring they operate efficiently and reliably under varying load conditions.</p>

                <span className="desc-h2">Instrumentation and Control Systems</span>

                <p>SMPS power supplies also deliver energy to the plant's instrumentation and control systems. These systems scan diverse facets of plant performance, including temperature, pressure, and emissions, assuring the plant functions within regulatory boundaries.</p>

                <span className="desc-h2">Additional Applications and Critical Roles</span>

                <p>Beyond the primary systems, coal-fired power plants depend on reliable power delivery to a wide variety of subsystems and components. Each of these applications plays a pivotal role in the plant's overall efficiency, safety, and environmental compliance.</p>

                <span className="desc-h2">Emissions Monitoring Systems</span>

                <p>Modern coal-fired power plants are under strict regulations that require continuous emissions monitoring. Powering systems such as Continuous Emissions Monitoring Systems (CEMS) is critical. These devices track the levels of sulfur dioxide (SO₂), nitrogen oxides (NO&#x2093;), particulate matter, and other pollutants in the exhaust gases. Reliable power ensures consistent operation and accurate reporting, helping the plant remain compliant with environmental laws and avoid costly penalties.</p>

                <span className="desc-h2">Boiler Management Systems</span>

                <p>Boiler systems are the heart of a coal-fired power plant. Managing the combustion process efficiently requires accurate control over fuel feeding, air supply, water levels, and steam pressure. Power sources are used to operate actuators, control valves, and sensor modules. Maintaining stable and uninterrupted power is essential for safe and optimized boiler operations, particularly during load fluctuations or start-up/shutdown sequences.</p>

                <span className="desc-h2">Lighting and Safety Systems</span>

                <p>A power plant must be well-lit to support 24/7 operations and to ensure the safety of personnel. From control room lighting to emergency lighting in hazardous areas, dependable power plays a role in creating a safe working environment. In case of emergencies, these systems must continue to function seamlessly to facilitate safe evacuation and reduce operational risks.</p>

                <span className="desc-h2">Coal Handling and Ash Handling Equipment</span>

                <p>Coal needs to be transported from storage yards to the furnace, and ash residues must be removed efficiently. These tasks rely on equipment such as conveyor belts, crushers, pulverizers, and ash slurry pumps. The performance of these mechanical systems directly affects the throughput and cleanliness of the plant, and steady power is critical for their uninterrupted operation.</p>

                <span className="desc-h2">Communication and Surveillance Infrastructure</span>

                <p>In a facility as large and complex as a coal-fired power plant, interdepartmental communication and continuous surveillance are vital. Powering systems like PA (public address) systems, intercoms, security cameras, and network routers supports real-time decision-making, monitoring of remote sections of the plant, and rapid response to safety alerts.</p>

                <span className="desc-h2">HVAC and Environmental Conditioning</span>

                <p>To protect sensitive electronics and maintain a comfortable working environment, Heating, Ventilation, and Air Conditioning (HVAC) systems are employed. These systems help maintain ambient temperatures in control rooms, server enclosures, and instrumentation cabinets. Stable power supply ensures these climate control systems run effectively, protecting equipment from thermal damage and ensuring staff comfort.</p>

                <span className="desc-h2">In a Nutshell</span>

                <p>Designing an efficient Switch-Mode Power Supply (SMPS) for coal-fired power plants is vital to improving functional efficiency, decreasing emissions, and assuring regulatory compliance. By focusing on power factor correction, input voltage stability, energy efficiency, secondary winding design, DC converters, AC-DC power conversion, and square wave optimization, plants can remarkably enhance performance while reducing their environmental impact.</p>

                <p>At AdorPowertron, we specialize in devising high-quality, durable SMPS power solutions tailored to the requirements of coal-fired power plants. Our expertise spans DC switch technology, power supply designs, switch-mode power supply (SMPS) systems, DC output regulation, linear power supply alternatives, and efficient electrical power management. With our advanced emission control systems and a wide range of innovative SMPS technologies, we ensure our customers achieve their efficiency and environmental objectives.</p>

                <a href="/contact-us" className="desc-red-link">Contact us Now !</a>

                <p className="desc-hashtags"><strong>#SMPS #SwitchModePowerSupply #EnergyEfficiency #EmissionControl #PowerPlantSolutions</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="desc-bottom-row">
                <div className="desc-bottom-nav">
                  <a href="/news/acusensus-traffic-technology" className="desc-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/transformer-bushings-coal-power" className="desc-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="desc-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/smps-for-coal-fired-power-plants/" className="desc-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fsmps-for-coal-fired-power-plants%2F&mode=login" className="desc-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsmps-for-coal-fired-power-plants%2F%26title%3DEfficient%2520SMPS%2520Power%2520for%2520Coal%2520Power%2520Plants%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsmps-for-coal-fired-power-plants%2F" target="blank" className="desc-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="desc-sidebar">

              {/* Recent Posts */}
              <div className="desc-sidebar-block">
                <p className="desc-sidebar-title">Recent Posts</p>
                <div className="desc-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="desc-recent-item">
                      <img src={post.img} alt={post.title} className="desc-recent-img" />
                      <div className="desc-recent-body">
                        <span className="desc-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="desc-sidebar-block">
                <p className="desc-sidebar-title">Social Media</p>
                <div className="desc-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" target="blank" className="desc-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="desc-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}